<template>
  <!-- The rows echo the ones on an event, so the two screens read as the same thing. -->
  <div class="tw:flex tw:flex-col tw:gap-5">
    <div
      v-for="type in preferences"
      :key="type.value"
      class="tw:flex tw:items-center tw:gap-3"
    >
      <div class="tw:flex tw:items-center tw:justify-center tw:w-9 tw:h-9 tw:rounded-lg tw:bg-primary/10 tw:text-primary tw:shrink-0">
        <Icon :name="type.icon" />
      </div>

      <label :for="`preference-${type.value}`" class="tw:text-sm tw:font-medium tw:m-0 tw:grow tw:min-w-0">
        {{ type.label }}
      </label>

      <Toggle
        :id="`preference-${type.value}`"
        :model-value="type.effective"
        :disabled="busy[type.value]"
        class="tw:shrink-0"
        @update:modelValue="save(type, $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import axios from 'axios'
import Toggle from '@/components/ui/Toggle.vue'
import { Icon } from '@/components/ui/icon'
import { toast } from 'vue-sonner'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * config/ziggy.php exposes only a handful of named routes to the browser, so these are
 * built from the base url the rest of the backoffice api layer already uses.
 */
const api = (path) => `${window.Laravel.backofficeApi}/${path}`

const preferences = ref([])
const busy = ref({})

const load = async () => {
  try {
    const { data } = await axios.get(api('notification-preference'))
    preferences.value = data.data
  } catch (error) {
    console.error('Failed to load notification preferences:', error)
    toast.error(t('Failed to update notification subscription'))
  }
}

/**
 * A general preference is an answer of its own: there is nothing above it to inherit
 * from, so the switch writes yes or no rather than clearing anything.
 */
const save = async (type, subscribed) => {
  const previous = { ...type }
  busy.value[type.value] = true
  Object.assign(type, { global: subscribed, effective: subscribed })

  try {
    await axios.post(api('notification-subscription'), {
      type: type.value,
      subscribed,
    })
    toast.success(t('Notification preference saved'))
  } catch (error) {
    Object.assign(type, previous)
    console.error('Failed to update subscription:', error)
    toast.error(t('Failed to update notification subscription'))
  } finally {
    busy.value[type.value] = false
  }
}

onMounted(load)
</script>
